import FeaturesCard from "./featuresCard/FeaturesCard";
import FeaturesStyleWrapper from "./Features.style";
import data from "../../../../assets/data/featuresDataV2"

const Features = () => {
  return (
    <FeaturesStyleWrapper className="v2_about_us_section" id="features">
      <div className="container">
        <div className="row features_items_row">
          {data.map((item, i) => (
            <div key={i} className="col-md-4">
              <FeaturesCard {...item} />
            </div>
          ))}
        </div>
      </div>
    </FeaturesStyleWrapper>
  );
};

export default Features;
